import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';

import { handleItemTax } from '../../lib/appointmentHelpers';

import { calculateInvoiceTaxFromItems } from './helpers';

const TaxCell = ({ event, field }) => {
  const {
    rowIndex,
    data,
    context: { type, values, setFieldValue, selectedItems }
  } = event || {};

  const { id } = data;

  const price = data?.[field];

  return (
    <CurrencyInput
      hideBorder
      style="percent"
      variant="secondary"
      disabled={!field}
      value={price}
      onBlur={(newTax) => {
        const updates = handleItemTax({
          setFieldValue,
          selectedItems,
          newTax,
          rowIndex,
          id,
          type,
          field
        });

        const invoiceTax = calculateInvoiceTaxFromItems({ ...values, ...updates });

        setFieldValue('invoice.tax', invoiceTax);
      }}
    />
  );
};

export default TaxCell;
